"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarsCoalition = void 0;
const CardName_1 = require("../../../CardName");
const CardType_1 = require("../../CardType");
const CardRenderer_1 = require("../../render/CardRenderer");
const Card_1 = require("../../Card");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const TurmoilPolicy_1 = require("../../../turmoil/TurmoilPolicy");
const Phase_1 = require("../../../Phase");
const MarsFirst_1 = require("../../../turmoil/parties/MarsFirst");
const Greens_1 = require("../../../turmoil/parties/Greens");
const Kelvinists_1 = require("../../../turmoil/parties/Kelvinists");
const Empower_1 = require("../../../turmoil/parties/Empower");
const Populists_1 = require("../../../turmoil/parties/Populists");
const SelectOption_1 = require("../../../inputs/SelectOption");
const DiscardCards_1 = require("../../../deferredActions/DiscardCards");
const GlobalParameter_1 = require("../../../GlobalParameter");
const Resources_1 = require("../../../Resources");
const SendDelegateToArea_1 = require("../../../deferredActions/SendDelegateToArea");
const Size_1 = require("../../render/Size");
const Tags_1 = require("../../Tags");
const KelvinistsDefaultAction_1 = require("../../turmoil/standardActions/KelvinistsDefaultAction");
const ScientistsDefaultAction_1 = require("../../turmoil/standardActions/ScientistsDefaultAction");
const KelvinistsPolicy3Action_1 = require("../../turmoil/standardActions/KelvinistsPolicy3Action");
const GreensPolicy4Action_1 = require("../../turmoil/standardActions/GreensPolicy4Action");
const MarsFirstPolicy4Action_1 = require("../../turmoil/standardActions/MarsFirstPolicy4Action");
const UnityPolicy2Action_1 = require("../../turmoil/standardActions/UnityPolicy2Action");
const UnityPolicy3Action_1 = require("../../turmoil/standardActions/UnityPolicy3Action");
const RedsPolicy3Action_1 = require("../../turmoil/standardActions/RedsPolicy3Action");
const SpomePolicy2Action_1 = require("../../turmoil/standardActions/SpomePolicy2Action");
const SpomePolicy4Action_1 = require("../../turmoil/standardActions/SpomePolicy4Action");
const EmpowerDefaultAction_1 = require("../../turmoil/standardActions/EmpowerDefaultAction");
const BureaucratsDefaultAction_1 = require("../../turmoil/standardActions/BureaucratsDefaultAction");
const BureaucratsPolicy3Action_1 = require("../../turmoil/standardActions/BureaucratsPolicy3Action");
const PopulistsPolicy3Action_1 = require("../../turmoil/standardActions/PopulistsPolicy3Action");
const TranshumansPolicy2Action_1 = require("../../turmoil/standardActions/TranshumansPolicy2Action");
const TranshumansPolicy3Action_1 = require("../../turmoil/standardActions/TranshumansPolicy3Action");
const CentristsDefaultAction_1 = require("../../turmoil/standardActions/CentristsDefaultAction");
const CentristsPolicy3Action_1 = require("../../turmoil/standardActions/CentristsPolicy3Action");
class MarsCoalition extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.MARS_COALITION,
            startingMegaCredits: 40,
            metadata: {
                cardNumber: 'R53',
                description: 'You start with 40 M€.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(40);
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('You may use the dominant party’s ruling policy IF IT IS DIFFERENT from the current ruling party.', (eb) => {
                            eb.startEffect.greyPlate('Dominant party');
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.action('Place a delegate.', (eb) => {
                            eb.empty().startAction.delegates(1);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct(player) {
        return player.game.turmoil.hasAvailableDelegates(player.id);
    }
    action(player) {
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send a delegate', { source: 'reserve' }));
        return undefined;
    }
    onTilePlaced(cardOwner, activePlayer, space) {
        if (cardOwner.id !== activePlayer.id || cardOwner.game.phase === Phase_1.Phase.SOLAR)
            return;
        if (!cardOwner.isCorporation(CardName_1.CardName.MARS_COALITION))
            return;
        const dominantPartyPolicy = MarsCoalition.getDominantPartyPolicyId(activePlayer);
        switch (dominantPartyPolicy) {
            case TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_DEFAULT_POLICY:
                MarsFirst_1.MARS_FIRST_DEFAULT_POLICY.onTilePlaced(cardOwner, space);
                break;
            case TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_2:
                Greens_1.GREENS_POLICY_2.onTilePlaced(cardOwner);
                break;
            case TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_4:
                Kelvinists_1.KELVINISTS_POLICY_4.onTilePlaced(cardOwner);
                break;
            case TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_2:
                Empower_1.EMPOWER_POLICY_2.onTilePlaced(cardOwner);
                break;
            case TurmoilPolicy_1.TurmoilPolicy.POPULISTS_POLICY_4:
                Populists_1.POPULISTS_POLICY_4.onTilePlaced(cardOwner);
                break;
            default:
                break;
        }
    }
    onCardPlayed(player, card) {
        if (!player.isCorporation(this.name))
            return;
        const dominantPartyPolicy = MarsCoalition.getDominantPartyPolicyId(player);
        switch (dominantPartyPolicy) {
            case TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_3:
                Greens_1.GREENS_POLICY_3.onCardPlayed(player, card);
                break;
            case TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_2:
                MarsFirst_1.MARS_FIRST_POLICY_2.onCardPlayed(player, card);
                break;
            default:
                break;
        }
    }
    static getDominantPartyPolicyId(activePlayer) {
        const turmoil = activePlayer.game.turmoil;
        const staticAgendas = turmoil.politicalAgendasData.staticAgendas;
        const dominantParty = turmoil.dominantParty;
        if (dominantParty.name === turmoil.rulingParty.name)
            return undefined;
        return staticAgendas.get(dominantParty.name).policyId;
    }
    static addPlayerAction(player, turmoilActions) {
        if (!player.isCorporation(CardName_1.CardName.MARS_COALITION))
            return;
        const dominantPartyPolicy = this.getDominantPartyPolicyId(player);
        switch (dominantPartyPolicy) {
            case TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_DEFAULT_POLICY:
                turmoilActions.push(new ScientistsDefaultAction_1.ScientistsDefaultAction());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_DEFAULT_POLICY:
                turmoilActions.push(new KelvinistsDefaultAction_1.KelvinistsDefaultAction());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_3:
                turmoilActions.push(new KelvinistsPolicy3Action_1.KelvinistsPolicy3Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_4:
                turmoilActions.push(new GreensPolicy4Action_1.GreensPolicy4Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_4:
                turmoilActions.push(new MarsFirstPolicy4Action_1.MarsFirstPolicy4Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_2:
                turmoilActions.push(new UnityPolicy2Action_1.UnityPolicy2Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_3:
                turmoilActions.push(new UnityPolicy3Action_1.UnityPolicy3Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.REDS_POLICY_3:
                turmoilActions.push(new RedsPolicy3Action_1.RedsPolicy3Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.SPOME_POLICY_2:
                turmoilActions.push(new SpomePolicy2Action_1.SpomePolicy2Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.SPOME_POLICY_4:
                turmoilActions.push(new SpomePolicy4Action_1.SpomePolicy4Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.EMPOWER_DEFAULT_POLICY:
                turmoilActions.push(new EmpowerDefaultAction_1.EmpowerDefaultAction());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_DEFAULT_POLICY:
                turmoilActions.push(new BureaucratsDefaultAction_1.BureaucratsDefaultAction());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_POLICY_3:
                turmoilActions.push(new BureaucratsPolicy3Action_1.BureaucratsPolicy3Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.POPULISTS_POLICY_3:
                turmoilActions.push(new PopulistsPolicy3Action_1.PopulistsPolicy3Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_2:
                turmoilActions.push(new TranshumansPolicy2Action_1.TranshumansPolicy2Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_3:
                turmoilActions.push(new TranshumansPolicy3Action_1.TranshumansPolicy3Action());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_DEFAULT_POLICY:
                turmoilActions.push(new CentristsDefaultAction_1.CentristsDefaultAction());
                break;
            case TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_3:
                turmoilActions.push(new CentristsPolicy3Action_1.CentristsPolicy3Action());
                break;
            default:
                break;
        }
    }
    static addPartyActionToActionsList(player, policy, options, title = 'Pay') {
        if (policy.canAct(player, true)) {
            options.push(new SelectOption_1.SelectOption(policy.description, title, () => policy.action(player, true)));
        }
    }
    static onGlobalParameterIncrease(player, parameter, steps = 1) {
        if (!player.isCorporation(CardName_1.CardName.MARS_COALITION))
            return;
        const dominantPartyPolicy = this.getDominantPartyPolicyId(player);
        switch (dominantPartyPolicy) {
            case TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_2:
                if (parameter === GlobalParameter_1.GlobalParameter.TEMPERATURE)
                    player.addResource(Resources_1.Resources.MEGACREDITS, steps * 3);
                break;
            case TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_3:
                player.drawCard(steps);
                player.game.defer(new DiscardCards_1.DiscardCards(player, steps, 'Turmoil Scientists - Select ' + steps + ' card(s) to discard'));
                break;
            case TurmoilPolicy_1.TurmoilPolicy.SPOME_DEFAULT_POLICY:
                if (parameter === GlobalParameter_1.GlobalParameter.VENUS)
                    player.addResource(Resources_1.Resources.MEGACREDITS, steps * 2);
                break;
            default:
                break;
        }
    }
    static applyDominantPartyPolicy(game, previousDominantParty) {
        const marsCoalitionPlayer = game.getPlayers().find((player) => player.isCorporation(CardName_1.CardName.MARS_COALITION));
        if (marsCoalitionPlayer === undefined)
            return;
        const turmoil = game.turmoil;
        const currentDominantParty = turmoil.dominantParty;
        if (previousDominantParty.name !== currentDominantParty.name)
            marsCoalitionPlayer.dominantPartyActionUsedCount = 0;
        const currentRulingParty = turmoil.rulingParty;
        const staticAgendas = turmoil.politicalAgendasData.staticAgendas;
        const currentRulingPolicy = staticAgendas.get(currentRulingParty.name).policyId;
        const dominantPartyPolicy = MarsCoalition.getDominantPartyPolicyId(marsCoalitionPlayer);
        switch (dominantPartyPolicy) {
            case TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_4:
                marsCoalitionPlayer.hasTurmoilScienceTagBonus = true;
                break;
            case TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_4:
                marsCoalitionPlayer.hasTranshumansColonyTradeOffset = true;
                break;
            default:
                if (currentRulingPolicy !== TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_4)
                    marsCoalitionPlayer.hasTurmoilScienceTagBonus = false;
                if (currentRulingPolicy !== TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_4)
                    marsCoalitionPlayer.hasTranshumansColonyTradeOffset = false;
                break;
        }
    }
    static handleSingleUsePolicyLogic(player, isDominantPartyAction) {
        if (isDominantPartyAction) {
            player.dominantPartyActionUsedCount += 1;
        }
        else {
            player.turmoilPolicyActionUsed = true;
        }
    }
    static handleTripleUsePolicyLogic(player, isDominantPartyAction) {
        if (isDominantPartyAction) {
            player.dominantPartyActionUsedCount += 1;
        }
        else {
            player.politicalAgendasActionUsedCount += 1;
        }
    }
    static shouldIncreaseMetalValue(player, partyName, policyId) {
        var _a, _b, _c, _d;
        if (!player.isCorporation(CardName_1.CardName.MARS_COALITION))
            return false;
        const game = player.game;
        if (!game.gameOptions.turmoilExtension)
            return false;
        if (game.phase !== Phase_1.Phase.ACTION)
            return false;
        const turmoil = game.turmoil;
        if (turmoil === undefined)
            return false;
        const dominantParty = turmoil.dominantParty;
        if (dominantParty === undefined)
            return false;
        if (policyId === undefined)
            policyId = dominantParty.policies[0].id;
        let currentPolicyId;
        if (turmoil.politicalAgendasData === undefined) {
            currentPolicyId = dominantParty.policies[0].id;
        }
        else if (partyName === PartyName_1.PartyName.MARS) {
            currentPolicyId = (_b = (_a = turmoil.politicalAgendasData.staticAgendas) === null || _a === void 0 ? void 0 : _a.get(PartyName_1.PartyName.MARS)) === null || _b === void 0 ? void 0 : _b.policyId;
        }
        else {
            currentPolicyId = (_d = (_c = turmoil.politicalAgendasData.staticAgendas) === null || _c === void 0 ? void 0 : _c.get(PartyName_1.PartyName.UNITY)) === null || _d === void 0 ? void 0 : _d.policyId;
        }
        return dominantParty.name === partyName && currentPolicyId === policyId;
    }
    static applyDominantPartyCardDiscounts(player, card, cost) {
        if (!player.isCorporation(CardName_1.CardName.MARS_COALITION))
            return cost;
        const dominantPartyPolicy = this.getDominantPartyPolicyId(player);
        if (card.tags.includes(Tags_1.Tags.SPACE) && dominantPartyPolicy === TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_4) {
            cost -= 2;
        }
        else if (card.tags.includes(Tags_1.Tags.ENERGY) && dominantPartyPolicy === TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_4) {
            cost -= 3;
        }
        else if (card.tags.includes(Tags_1.Tags.EARTH) && dominantPartyPolicy === TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_POLICY_4) {
            const earthTagCount = card.tags.filter((tag) => tag === Tags_1.Tags.EARTH).length;
            cost -= earthTagCount * 3;
        }
        else if (card.cardType === CardType_1.CardType.EVENT && dominantPartyPolicy === TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_4) {
            cost -= 2;
        }
        return cost;
    }
    static getRequirementsBonus(player, requirementsBonus) {
        if (!player.isCorporation(CardName_1.CardName.MARS_COALITION))
            return requirementsBonus;
        const dominantPartyPolicy = this.getDominantPartyPolicyId(player);
        if (dominantPartyPolicy === TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_2)
            requirementsBonus += 2;
        if (dominantPartyPolicy === TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_3 && player.turmoilPolicyActionUsed === true) {
            requirementsBonus += 50;
        }
        return requirementsBonus;
    }
    static checkBonusWildTag(player, tag, tagCount) {
        if (!player.isCorporation(CardName_1.CardName.MARS_COALITION))
            return tagCount;
        const dominantPartyPolicy = this.getDominantPartyPolicyId(player);
        if (tag === Tags_1.Tags.WILDCARD && dominantPartyPolicy === TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_DEFAULT_POLICY) {
            tagCount += 1;
        }
        return tagCount;
    }
}
exports.MarsCoalition = MarsCoalition;
//# sourceMappingURL=MarsCoalition.js.map